export default {
  HEIGHT: 700,
  WIDTH: 1236,
  FILENAME: 'dashboard.html',
  SERVICE_CONNECTED: 'service-connected.html',
  UPLOADING_CANCEL_CODE: -7799,
  HELP_URL: 'https://www.wix.com/support/html5/wix-video/getting-started-with-wix-video',
};



// WEBPACK FOOTER //
// ./src/shared/constants/dashboard.js